import { Directive, ElementRef, AfterViewInit } from '@angular/core';
import { IStepContentChildOffset } from '../interface';

@Directive({
  selector: '[skyBlockStepContentElement]',
  standalone: false,
})
export class StepContentElementDirective implements AfterViewInit {
  private elementPadding = 0;

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    const elementStyles = getComputedStyle(this.elementRef.nativeElement);

    this.elementPadding = parseInt(elementStyles.paddingBottom || '') + parseInt(elementStyles.paddingTop || '');
  }

  getViewportWidth(): number {
    return this.elementRef.nativeElement.offsetWidth;
  }

  getViewportHeight(): number {
    return this.elementRef.nativeElement.offsetHeight - this.elementPadding;
  }

  getChildOffsets(child: HTMLElement): IStepContentChildOffset | null {
    const offsetElementsUnderViewportElement: HTMLElement[] = [];
    let offsetHierarchyElement: HTMLElement | null = child;
    let isChildElement = false;
    for (;;) {
      if (!offsetHierarchyElement) {
        break;
      }
      if (offsetHierarchyElement === this.elementRef.nativeElement) {
        isChildElement = true;
        break;
      }
      // eslint-disable-next-line functional/immutable-data
      offsetElementsUnderViewportElement.push(offsetHierarchyElement);
      offsetHierarchyElement = offsetHierarchyElement.offsetParent as HTMLElement;
    }
    if (!isChildElement) {
      return null;
    }
    return offsetElementsUnderViewportElement.reduce(
      (offsets, el) => {
        // eslint-disable-next-line functional/immutable-data
        offsets.offsetLeft += el.offsetLeft;
        // eslint-disable-next-line functional/immutable-data
        offsets.offsetTop += el.offsetTop;
        return offsets;
      },
      {
        offsetLeft: 0,
        offsetTop: 0,
      },
    );
  }
}
